import { render, staticRenderFns } from "./EditarTasasCambio.vue?vue&type=template&id=5a33045a"
import script from "./EditarTasasCambio.vue?vue&type=script&lang=js"
export * from "./EditarTasasCambio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports